
import React, { useMemo, useRef, useState, useEffect } from 'react';
import MaterialReactTable from 'material-react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComments, faCalendarAlt, faRefresh } from '@fortawesome/free-solid-svg-icons';
import useUtils from '../../../utiles/useUtiles';
import Footer from '../../components/Footer';
import ModalComment from './ModalComment';
import moment from 'moment';

// import ModalAddUser from '../../components/ModalAddUser';

const AppointmentContent: React.FC = () => {

    const [scheduleList, setScheduleList] = useState<any>( { count: 0, rows: [] } );
    const [loading, setLoading] = useState<boolean>( false );
    const [showModalComment, setShowModalComment] = useState<boolean>( false );
    const [selectedRow, setSelectedRow] = useState<any>( null );
    const [searchText, setSearchText] = useState<string>( '' );
    const [pagination, setPagination] = useState<any>( {
        pageIndex: 0,
        pageSize: 10
    } );
    const { axiosRequest, baseUrl, toastInstance, loadingScreen } = useUtils()
    const axios = axiosRequest();
    const toast = toastInstance();

    useEffect( () => {
        fetchAppointments();
    }, [pagination.pageIndex, pagination.pageSize] );

    const columns = useMemo(
        () => [
            {
                accessorKey: 'client_name',
                header: 'Name',
                minSize: 50,
                maxSize: 120,
                Cell: ( { cell }: any ) => <span>{cell.getValue() || 'NA'}</span>,
            },
            {
                accessorKey: 'client_email',
                header: 'Email',
                minSize: 50,
                maxSize: 120,
                Cell: ( { cell } ) => <span>{cell.getValue()}</span>,
            },
            {
                accessorKey: 'schedule_start_date',
                header: 'Scheduled Start Date',
                minSize: 50,
                maxSize: 120,
                Cell: ( { cell } ) => <span>{
                    moment(cell.getValue()).local().format('YYYY-MM-DD HH:mm:ss')
                }</span>,
            },
            {
                accessorKey: 'schedule_end_date',
                header: 'Scheduled End date',
                minSize: 50,
                maxSize: 120,
                Cell: ( { cell } ) => <span>{
                    moment(cell.getValue()).local().format('YYYY-MM-DD HH:mm:ss')
                }</span>,
            },
            {
                accessorKey: 'actions',
                header: 'Action',
                minSize: 30,
                maxSize: 60,
                Cell: ( { cell } ) => <div>
                    <FontAwesomeIcon
                        title='View Comment'
                        icon={faComments}
                        className="isCursor ml-2"
                        onClick={() => {
                            setSelectedRow( cell.row.original );
                            setShowModalComment( true );
                        }}
                    />
                    {
                        cell.row.original && cell.row.original['html_link'] && (
                            <FontAwesomeIcon
                                title='View Google Calendar'
                                icon={faCalendarAlt}
                                className="isCursor ml-2"
                                onClick={() => {
                                    window.open(cell.row.original['html_link'],'_blank')
                                }}
                            />
                        ) || ""
                    }
                </div>,
            }
        ],
        [],
    );

    const fetchAppointments = async () => {
        setLoading( true );
        var queryString = `page=${pagination.pageIndex}&pageSize=${pagination.pageSize}`;
        if ( searchText ) {
            queryString += `&email=${searchText}`;
        }

        const request = await axios.get( `${baseUrl()}/schedule_meetings/appointments?${queryString}` );
        const { error, total, result } = request.data;
        setLoading( false );
        if ( error ) {
            toast.error( 'Error to fetch scheduled appoinments' );
        } else {
            setScheduleList(result);
        }
    };

    return (
        <>
            <div className='mb-4 row'>
                <div className={`col-md-${process.env.REACT_APP_ENV !== 'production' ? 8: 10}`}>
                    <input type={"text"} name="searchText" placeholder="Email" className="form-control" autoComplete='new-password' onChange={( e ) => setSearchText( e.target.value )} />
                </div>
                <div className='col-md-2'>
                    <button type="button" className="btn btn-md btn-custom-secondary" onClick={fetchAppointments}>Search</button>
                </div>
            </div>
            <MaterialReactTable
                columns={columns}
                data={scheduleList?.rows}
                rowCount={scheduleList?.count}
                enableColumnOrdering={false}
                enableRowSelection={false}
                enableSelectAll={false}
                enableColumnActions={false}
                manualPagination
                onPaginationChange={setPagination}
                state={{ pagination }}
                enableSorting={false}
                enableGlobalFilter={false}
                enableFullScreenToggle={false}
                enableDensityToggle={false}
                enableHiding={false}
                enableColumnFilters
                enableFilters={false}
            />

            {
                showModalComment && 
                <ModalComment 
                    show={showModalComment} 
                    handleClose={() => {
                        setShowModalComment(false);
                        setSelectedRow(null)
                    }}
                    selectedRow={selectedRow} 
                /> || <></>
            }
            {loadingScreen( loading )}
        </>
    );
}

export default AppointmentContent